import { Box, Button, Text } from "@chakra-ui/react";
import { Plus } from "lucide-react";
import { colord } from "colord";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Modal from "@components/Modal";
import Chevron from "@components/icons/Chevron";
import { useCustomerUsersCustomers } from "@api/hooks";
import { appTheme } from "@styles/Theme";

// TODO: Phase 5 - Import routes from routes.ts
const jobCreateRoute = "/uppdrag/skapa-uppdrag";

/**
 * "Nytt uppdrag" button. Asks which customer (enhet) the job is for when the
 * user belongs to more than one, otherwise goes straight to the create flow.
 */
const NewJobButton = () => {
	const navigate = useNavigate();
	const { customers } = useCustomerUsersCustomers();
	const [showCustomerModal, setShowCustomerModal] = useState(false);

	const handleCustomerSelection = (customerId: string) => {
		navigate(`${jobCreateRoute}?customer=${customerId}`);
	};

	const handleCreateOrder = () => {
		if (!customers?.customers?.length) return;
		if (customers.customers.length > 1) setShowCustomerModal(true);
		else handleCustomerSelection(customers.customers[0].id);
	};

	return (
		<>
			<Button
				height={{ base: "36px", md: "40px" }}
				px={5}
				leftIcon={<Plus size={18} strokeWidth={2.5} />}
				flexShrink={0}
				fontSize={{ base: "14px", md: "16px" }}
				fontWeight={500}
				bg="#29A54D"
				_hover={{ opacity: 0.8 }}
				color="#FFFFFF"
				borderRadius={"full"}
				size="sm"
				onClick={handleCreateOrder}
			>
				Nytt uppdrag
			</Button>

			<Modal show={showCustomerModal} onClose={() => setShowCustomerModal(false)}>
				<>
					<Text fontSize={20} fontWeight={600} align={"center"} mb={6}>
						Åt vem beställer du?
					</Text>
					<Box maxH={"70vh"} overflowY={"auto"}>
						{customers?.customers?.map((c) => (
							<Choice
								key={c.id}
								onClick={() => handleCustomerSelection(c.id)}
								style={{ width: "100%", margin: "0 0 1rem 0" }}
							>
								{c.name}
								<Chevron color={appTheme.colors.brand} />
							</Choice>
						))}
					</Box>
				</>
			</Modal>
		</>
	);
};

export default NewJobButton;

const Choice = styled.div`
	border: 2px solid ${(props) => props.theme.colors.brand};
	background-color: ${(props) => colord(props.theme.colors.brand).lighten(0.5).toHex()};
	text-align: center;
	padding: 0.75rem 1rem;
	border-radius: 25px;
	font-weight: 500;
	font-size: 15px;
	position: relative;
	cursor: pointer;
	width: 50vw;
	max-width: 650px;
	width: 100%;
	margin: 1rem;

	transition: transform 0.125s;

	&:hover {
		background-color: ${(props) => colord(props.theme.colors.brand).lighten(0.45).toHex()};
		transform: scale(0.99);
	}
	svg {
		position: absolute;
		right: 1rem;
		top: 0.9rem;
	}
`;
